import WolfTooltip from '@components/ui/WolfTooltip';
import { Box, ListItemButton, ListItemButtonProps, Typography, styled } from '@mui/material';
import { AreaIcon24, PremiumIcon24 } from './WolfIcons';

interface SidebarButtonProps extends ListItemButtonProps {
  icon: React.ReactNode;
  label?: string;
  tooltip?: string;
  premium?: boolean;
  collapsed?: boolean;
}

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(1, 0),
  width: '100%',
  '&:hover': {
    backgroundColor: theme.palette.primaryFrozen.main,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.primaryFrozen.main,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primaryFrozen.dark,
    },
  },
}));

const Label = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  textAlign: 'center',
  color: theme.palette.text.primary,
}));

const SidebarButton: React.FC<SidebarButtonProps> = ({ icon, label, tooltip, premium, collapsed, ...props }) => (
  <WolfTooltip title={tooltip || ''} placement="right">
    <StyledListItemButton {...props}>
      <Box className="flex flex-wrap justify-start items-center !h-8 !md-h-12 !lg:h-14 !px-6">
        {icon}
        {premium && collapsed && (
          <PremiumIcon24 className="absolute right-3 top-2" height="10" style={{ height: 10, width: 10 }} />
        )}
        {label && (
          <Box className="ml-2">
            <Label variant="body14" color="primary">
              {label}
            </Label>
          </Box>
        )}
        {premium && !collapsed && <PremiumIcon24 />}
      </Box>
    </StyledListItemButton>
  </WolfTooltip>
);

export default SidebarButton;
